import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SignalsFeed from "./SignalsFeed";
import { ScorePill, fetchScores } from "./AccountScore";
import "./accountSignals.scss";

/**
 * Signals on an account's page: its score (the same pill as the Accounts list) and the feed itself for this
 * account, the same rows and actions as the Signals page. Nothing is looked up here beyond what Signals stored.
 */
const AccountSignals = ({ accountId }) => {
  const [score, setScore] = useState(undefined);
  useEffect(() => {
    if (!accountId) return undefined;
    let live = true;
    setScore(undefined);
    fetchScores([accountId]).then(s => live && setScore((s || {})[accountId] || null));
    return () => { live = false; };
  }, [accountId]);
  if (!accountId) return null;
  return (
    <section className="acov-signals">
      <div className="acov-signals__head">
        <h3>Signals</h3>
        {score !== undefined && <ScorePill item={score} accountId={accountId} onScored={setScore} />}
        <span className="sg-grow" />
        <Link className="acov-signals__all" to="/signals">Open Signals</Link>
      </div>
      <SignalsFeed entityId={accountId} embedded view="all" emptyText="No signals recorded here yet." />
    </section>
  );
};

export default AccountSignals;
